// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const OpenerLeadPage = () => import('@/modules/openers/views/OpenerLeadPage')
const OpenerCoastLeads = () => import('@/modules/openers/views/OpenerCoastLeads')
const OpenerWarmTransferList = () => import('@/modules/openers/views/OpenerWarmTransferList')
const OpenerCallbackList = () => import('@/modules/openers/views/OpenerCallbackList')
const OpenerDashboard = () => import('@/modules/openers/views/OpenerDashboard')
const NewOpenerDashboard  = () => import('@/modules/openers/views/NewOpenerDashboard')

var routes = [
    {
        path: '/openers',
        redirect: '/openers/leads',
        name: 'Openers',
        component: DefaultContainer,
        children: [
            {
				path: '/openers',
                name: 'OpenerLeadPage',
				redirect: '/openers/new-dashboard',
                component: OpenerLeadPage,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
				children: [
					{
						path: 'new-dashboard',
						name: 'NewOpenerDashboard',
						component: NewOpenerDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'new-dashboard',
						},
					},
					{
						path: 'dashboard',
						name: 'OpenerDashboard',
						component: OpenerDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'dashboard',
							role_filter: 'opener',
						},
					},
					{
						path: 'coast/:coast',
						name: 'OpenerCoastLeads',
						component: OpenerCoastLeads,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'coast',
							role_filter: 'opener',
						},
					},
					{
						path: 'warm-transfer-list',
						name: 'OpenerWarmTransferList',
						component: OpenerWarmTransferList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'warm-transfer-list',
							role_filter: 'opener',
						},
					},
					{
						path: 'callbacks',
						name: 'OpenerCallbackList',
						component: OpenerCallbackList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'callbacks',
							role_filter: 'opener',
						},
					},

				]
            },
        ]
    },
];

export default routes;
